import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./CustomerUIHelpers";

const CustomerUIContext = createContext();

export function useCustomerUIContext() {
  return useContext(CustomerUIContext);
}

export const CustomerUIConsumer = CustomerUIContext.Consumer;

export function CustomerUIProvider({ CustomerUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: CustomerUIEvents?.openEditProductPage,
    openDeleteProductDialog: CustomerUIEvents?.openDeleteProductDialog,
    openDeleteCustomerDialog: CustomerUIEvents?.openDeleteCustomerDialog,
    openFetchCustomerDialog: CustomerUIEvents?.openFetchCustomerDialog,
    openUpdateCustomerStatusDialog:
      CustomerUIEvents?.openUpdateCustomerStatusDialog,
  };

  return (
    <CustomerUIContext.Provider value={value}>
      {children}
    </CustomerUIContext.Provider>
  );
}
